import { useMemo } from 'react';
import { createSchemaContext, resolveRef } from "../utils/schema-context.js";
import { useFormStoreSelector } from "./use-form-store.js";
/**
 * Hook that returns a SchemaContext for the current form.
 * Use this with context-first schema utility functions.
 */
export function useSchemaContext() {
    const rootSchema = useFormStoreSelector((s) => s.schema);
    return useMemo(() => createSchemaContext(rootSchema), [rootSchema]);
}
/**
 * Hook that resolves a schema's $ref if present.
 * Convenience wrapper around resolveRef with memoization.
 */
export function useResolvedSchema(schema) {
    const ctx = useSchemaContext();
    return useMemo(() => resolveRef(ctx, schema), [ctx, schema]);
}
